import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../features/auth/AuthContext";
import { TimeRange } from "../../utils/timerange";
import { fetchProtocolPerformance } from "../queries/dashboard";

interface UseDashboardDataParams {
  timeRange: TimeRange;
  timezone: string;
  user: string;
  permittedEmails: string[] | null;
}

export const useProtocolPerformance = (params: UseDashboardDataParams) => {
  const { tenantId } = useAuth();
  const { timeRange, timezone, user, permittedEmails } = params;

  return useQuery({
    queryKey: ["protocolPerformance", tenantId, timeRange, timezone, user, permittedEmails],
    queryFn: () => fetchProtocolPerformance(params),
    staleTime: 1 * 60 * 1000, // 1 minute - dashboard data changes moderately frequently
    gcTime: 2 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};
